<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-12-26 10:18:59
 * @LastEditors: whaoo
 * @LastEditTime: 2024-01-04 16:53:09
-->
<template>
    <div>
        <div class="search_box">
            <el-button type="warning" size="large" @click="pageTo">切换到护理报告模式</el-button>
            <img class="logo_box" src="../../assets/logo_2.png">
        </div>

        <div class="container_box flex_box" v-if="!nodata">
            <div class="flex_item" v-for="(item, index) in dataList" :key="index">
                <div class="box_title " :style="{ 'line-height': lh }">
                    <span style="margin-right: 10px;">{{ item.bed_number }}床</span>
                    <span style="margin-right: 10px;">{{ item.name }}</span>
                    <span>{{ item.patient_id }}</span>
                </div>
                <div class="data_box" :style="{ height: `calc(100% - ${lh})` }">
                    <div class="left">
                        <div class="hr_data border_bottom">
                            <div class="type_title">
                                <img src="../../assets/hr.png" alt="">
                                <span>HR</span>
                            </div>
                            <div class="value">
                                {{ item.lastData.heartrate ? item.lastData.heartrate : '--' }}<span class="unit">bpm</span>
                            </div>
                        </div>
                        <div class="spo2_data">
                            <div class="type_title">
                                <img src="../../assets/spo2.png" alt="">
                                <span>SpO2</span>
                            </div>
                            <div class="value">
                                {{ item.lastData.spo2 ? item.lastData.spo2 : '--' }}<span class="unit">%</span>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div :id="`chart${(index + 1) * 2 - 1}`" style=" width: 100%; height: 50%;">
                        </div>
                        <div :id="`chart${(index + 1) * 2}`" style=" width: 100%; height: 50%;">
                        </div>
                    </div>
                </div>

                <!-- <div class="hr_box flex_box mb_20">
                    <div class="left">
                        <img src="../../assets/hr_bg.png">
                        <div class="hr_value">
                            {{ item.lastData.heartrate ? item.lastData.heartrate : '--' }}<span class="unit">bpm</span>
                        </div>
                    </div>
                    <div class="right" :id="`chart${(index + 1) * 2 - 1}`">

                    </div>
                </div>
                <div class="spo2_box flex_box">
                    <div class="left">
                        <img src="../../assets/spo2_bg.png">
                        <div class="spo2_value">
                            {{ item.lastData.spo2 ? item.lastData.spo2 : '--' }}<span class="unit">%</span>
                        </div>
                    </div>
                    <div class="right" :id="`chart${(index + 1) * 2}`">

                    </div>
                </div> -->
            </div>

        </div>

        <div v-else class="nodata">
            <img src="../../assets/nodata.png" alt="">
        </div>
    </div>
</template>

<script>
function getRoundHourTimestamps(timestamp) {
    let currentDate = new Date(timestamp);

    // 设置分钟、秒数和毫秒为 0
    currentDate.setMinutes(0);
    currentDate.setSeconds(0);
    currentDate.setMilliseconds(0);

    // 获取当前小时的开始时间戳
    let startTimestamp = currentDate.getTime();

    // 将当前小时加上一小时得到结束时间戳
    currentDate.setHours(currentDate.getHours() + 1);
    let endTimestamp = currentDate.getTime();

    return [startTimestamp, endTimestamp];
}
export default {
    data() {
        return {
            nodata: true,
            dataList: [],
            hrOptions: {
                xAxis: {
                    type: 'time',
                    data: [],
                    // interval:3600*1000,
                    splitNumber:25,
                    axisLabel: {
                        color: "#23FA00",
                        formatter: '{HH}:{mm}',
                        // interval:5
                        hideOverlap:true,
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#23FA0000"
                        }
                    },
                    axisTick: {
                        show: true,
                        alignWithLabel: true,
                        interval: 0,
                        lineStyle: {
                            color: "#23FA00AA"
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    name: "bpm",
                    nameTextStyle: {
                        color: "#23FA00",
                        padding: [0, 0, 0, -40],//控制y轴标题位置
                    },
                    axisLabel: {
                        color: "#23FA00",
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#23FA0055'
                        }
                    },
                    min: 0,
                    max: 180
                },
                backGroundColor: '#000000',
                grid: {
                    top: '30%',
                    bottom: "16%",
                    right: "5%",
                    left: "50px",
                },
                series: [
                    {
                        data: [],
                        type: 'line',
                        connectNulls: false,
                        lineStyle: {
                            color: "#23FA00",
                        },
                        symbol: "none",
                        markLine: {
                            symbol: ['none', 'none'], //['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
                            label: {
                                position: "insideEndTop", //将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
                                color: "#FF0000",
                            },
                            data: [
                                {
                                    yAxis: 160,
                                    lineStyle: { //警戒线的样式 ，虚实 颜色
                                        type: "dashed", //样式  ‘solid’和'dotted'
                                        color: "#FF0000",
                                        width: 1   //宽度
                                    },
                                    label: {
                                        formatter: '高心率阈值：{c}'
                                    }
                                },
                                {
                                    yAxis: 60,
                                    lineStyle: { //警戒线的样式 ，虚实 颜色
                                        type: "solid", //样式  ‘solid’和'dotted'
                                        color: "#FF0000",
                                        width: 1   //宽度
                                    },
                                    label: {
                                        formatter: '低心率阈值：{c}'
                                    }
                                }
                            ]
                        }
                    }
                ]
            },
            spo2Options: {
                xAxis: {
                    type: 'time',
                    splitNumber:25,
                    data: [],
                    axisLabel: {
                        color: "#32C3F1",
                        hideOverlap:true,
                        formatter: '{HH}:{mm}'
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#32C3F100"
                        }
                    },
                    axisTick: {
                        show: true,
                        alignWithLabel: true,
                        interval: 0,
                        lineStyle: {
                            color: "#32C3F1AA"
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    name: "%",
                    nameTextStyle: {
                        color: "#32C3F1",
                        padding: [0, 0, 0, -30],//控制y轴标题位置
                    },
                    axisLabel: {
                        color: "#32C3F1",
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#32C3F155'
                        }
                    },
                    min: 0,
                    max: 100
                },
                backGroundColor: '#000000',
                grid: {
                    top: '30%',
                    bottom: "16%",
                    right: "5%",
                    left: "50px",
                },
                series: [
                    {
                        data: [],
                        connectNulls: false,
                        type: 'line',
                        lineStyle: {
                            color: "#32C3F1",
                        },
                        symbol: "none",
                        markLine: {
                            symbol: ['none', 'none'], //['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
                            label: {
                                position: "insideEndTop", //将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
                                color: "#ff0000",
                                formatter: '低血氧阈值：{c}'
                            },
                            lineStyle: { //警戒线的样式 ，虚实 颜色
                                type: "solid", //样式  ‘solid’和'dotted'
                                color: "#ff0000",
                                width: 1   //宽度
                            },
                            data: [{
                                yAxis: 90
                            }]
                        }
                    },

                ]
            },
            chartObj: {},
            zone_number: '',
            lh: "",
            interval: ''
        }
    },

    mounted() {
        this.checkLogin()
        this.zone_number = this.$cookies.get('zone_number')
        this.fetchData()
        this.interval = setInterval(() => {
            this.fetchData()
        }, 600000);
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    methods: {
        checkLogin() {
            // if (!this.$cookies.get('token')) {
            //     this.$router.push('/login')
            // }
        },
        pageTo() {
            this.$router.push({
                path: '/device_list',
                query: {
                    zone_number: this.zone_number
                }
            })
        },
        fetchData() {
            this.checkLogin()

            let data = {
                zone_number: this.zone_number,
                start: parseInt(new Date().getTime() / 1000) - 86400,
                end: parseInt(new Date().getTime() / 1000)
            }
            this.$http({
                url: '/api/output/signEcgNow',
                method: "GET",
                params: data,
                headers: {
                    // 'Token': this.$cookies.get('token')
                }
            }).then(res => {
                if (res.result && res.result.length > 0) {
                    this.nodata = false
                } else {
                    this.nodata = true
                }
                let arr = res.result
                arr.forEach((item, index) => {
                    arr[index].lastData = {}
                    item.list.forEach((e, i) => {
                        if (i == item.list.length - 1) {
                            arr[index].lastData = e
                        }

                    })
                })

                this.dataList = arr
                this.$nextTick(() => {
                    this.lh = document.getElementsByClassName('box_title')[0].clientHeight + 'px'
                    this.$nextTick(() => {

                        this.dataList.forEach((item, index) => {
                            this.chartObj[`data_x_${(index + 1) * 2 - 1}`] = []
                            this.chartObj[`data_x_${(index + 1) * 2}`] = []
                            this.chartObj[`data_y_${(index + 1) * 2 - 1}`] = []
                            this.chartObj[`data_y_${(index + 1) * 2}`] = []

                            item.list.forEach((e, i) => {
                                if (i == item.list.length - 1) {
                                    this.dataList[index].lastData = e
                                }
                                // this.chartObj[`data_x_${(index + 1) * 2 - 1}`].push(this.$dateFtt.dateFtt('hh:00', new Date(e.insert_time * 1000)))
                                // this.chartObj[`data_x_${(index + 1) * 2}`].push(this.$dateFtt.dateFtt('hh:00', new Date(e.insert_time * 1000)))
                                // this.chartObj[`data_y_${(index + 1) * 2 - 1}`].push(e.heartrate)
                                // this.chartObj[`data_y_${(index + 1) * 2}`].push(e.spo2)

                                this.chartObj[`data_y_${(index + 1) * 2 - 1}`].push([e.insert_time * 1000, e.heartrate])
                                this.chartObj[`data_y_${(index + 1) * 2}`].push([e.insert_time * 1000, e.spo2])
                            })

                            this.chartObj[`chartDom${(index + 1) * 2 - 1}`] = document.getElementById(`chart${(index + 1) * 2 - 1}`);
                            this.chartObj[`myChart${(index + 1) * 2 - 1}`] = echarts.init(this.chartObj[`chartDom${(index + 1) * 2 - 1}`]);
                            this.chartObj[`option${(index + 1) * 2 - 1}`] = JSON.parse(JSON.stringify(this.hrOptions))
                            // this.chartObj[`option${(index + 1) * 2 - 1}`].xAxis.data = this.chartObj[`data_x_${(index + 1) * 2 - 1}`]
                            this.chartObj[`option${(index + 1) * 2 - 1}`].series[0].data = this.chartObj[`data_y_${(index + 1) * 2 - 1}`]
                            this.chartObj[`option${(index + 1) * 2 - 1}`].series[0].markLine.data[0].yAxis = item.high_heartrate_value
                            this.chartObj[`option${(index + 1) * 2 - 1}`].series[0].markLine.data[1].yAxis = item.low_heartrate_value

                            this.chartObj[`option${(index + 1) * 2 - 1}`].xAxis.min = function (value) {
                                return getRoundHourTimestamps(parseInt(new Date().getTime()) - 86400000)[0]
                            }
                            this.chartObj[`option${(index + 1) * 2 - 1}`].xAxis.max = function (value) {
                                return getRoundHourTimestamps(parseInt(new Date().getTime()))[1]
                            }

                            this.chartObj[`chartDom${(index + 1) * 2}`] = document.getElementById(`chart${(index + 1) * 2}`);
                            this.chartObj[`myChart${(index + 1) * 2}`] = echarts.init(this.chartObj[`chartDom${(index + 1) * 2}`]);
                            this.chartObj[`option${(index + 1) * 2}`] = JSON.parse(JSON.stringify(this.spo2Options))
                            // this.chartObj[`option${(index + 1) * 2}`].xAxis.data = this.chartObj[`data_x_${(index + 1) * 2}`]
                            this.chartObj[`option${(index + 1) * 2}`].series[0].data = this.chartObj[`data_y_${(index + 1) * 2}`]

                            this.chartObj[`option${(index + 1) * 2}`].series[0].markLine.data[0].yAxis = item.spo2

                            this.chartObj[`option${(index + 1) * 2}`].xAxis.min = function (value) {
                                return getRoundHourTimestamps(parseInt(new Date().getTime()) - 86400000)[0]
                            }
                            this.chartObj[`option${(index + 1) * 2}`].xAxis.max = function (value) {
                                return getRoundHourTimestamps(parseInt(new Date().getTime()))[1]
                            }


                            this.chartObj[`option${(index + 1) * 2 - 1}`] && this.chartObj[`myChart${(index + 1) * 2 - 1}`].setOption(this.chartObj[`option${(index + 1) * 2 - 1}`]);
                            this.chartObj[`option${(index + 1) * 2}`] && this.chartObj[`myChart${(index + 1) * 2}`].setOption(this.chartObj[`option${(index + 1) * 2}`]);

                        })

                    })
                })



            })
        }
    }
}

</script>
<style  scoped>
.search_box {
    padding: 20px;
    position: relative;
    background-color: #F5F7FB;
}

.logo_box {
    height: 40px;
    width: auto;
    position: absolute;
    right: 20px;
    top: 20px;
}

.container_box {
    min-height: calc(100vh - 80px);
    background-color: #000000;
    padding: 20px;
    flex-wrap: wrap;
}

.flex_item {
    width: calc(50% - 10px);
    height: calc(50vh - 80px);
    margin-bottom: 20px;
    box-shadow: 0 0 5px 1px #646464;
    border-radius: 5px;
}

.box_title {
    color: #ffffff;
    font-size: 16px;
    height: 12%;
    /* line-height: 100%; */
    padding-left: 14px;
    font-weight: bold;
    background-color: #333333;
}

.mb_20 {
    margin-bottom: 20px;
}

.flex_box {
    justify-content: space-between;
    display: flex;
}

/* 
.left {
    width: 169px;
    height: 132px;
    position: relative;
}

.left img {
    width: 100%;
}

.right {
    width: calc(100% - 132px - 60px);
    height: 145px;
}

.hr_value,
.spo2_value {
    font-size: 66px;
    position: absolute;
    bottom: -5px;
    left: 5px;
    width: 100%;
}

.hr_value {
    color: #23FA00;
}

.spo2_value {
    color: #32C3F1;
}

.unit {
    font-size: 14px;
    position: absolute;
    right: 10px;
    bottom: 15px;
} */

.nodata {
    width: 30%;
    margin: auto;
}

.nodata img {
    width: 100%;
}

.data_box {
    width: 100%;

    display: flex;
}

.left {
    width: 130px;
    height: 100%;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.left div {
    height: 50%;
    width: 100%;
    position: relative;
}

.border_bottom {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.type_title {
    /* padding: 20px; */
    font-size: 0;
    text-wrap: nowrap;
    position: absolute;
    left: 20px;
    top: 20px;
}

.type_title img {
    width: 20px;
    margin-right: 10px;
}

.type_title span {
    font-size: 18px;
    font-weight: bold;
    position: relative;
    bottom: 2px;
}

.hr_data {
    color: #23FA00;
}

.spo2_data {
    color: #32C3F1;
}

.value {
    font-size: 50px;
    text-align: center;
    font-weight: bold;
    text-align: right;
    padding-right: 20px;
}

.unit {
    font-size: 12px;
    position: absolute;
    right: 20px;
    top: -5px;
    font-weight: 500;
}

.right {
    width: calc(100% - 130px);
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/all_device_data_1.vue